module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "p01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v("Matriarch")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("‘I speak the truth, not so much as I would, but as much as I dare; and I dare a little more, as I grow older.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTAIGNE")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5453234f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795338557_epub_p01_r1.vue
// module id = 78
// module chunks = 0